import { Injectable } from '@angular/core'

import { mapValues as _mapValues } from 'lodash'

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  encode(queryParams?: Record<string, any>): Record<string, string> | null {
    return queryParams
      ? _mapValues(queryParams, (value) =>
          typeof value === 'object' ? JSON.stringify(value) : value
        )
      : null
  }

  decode(queryParams?: Record<string, string>): Record<string, any> {
    return queryParams
      ? _mapValues(queryParams, (value) => {
          try {
            return JSON.parse(value)
          } catch {
            return value
          }
        })
      : {}
  }
}
